import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import CommentBoxEditor from './CommentBoxEditor';
import CommentBoxEditorV2 from '../../lego.editor_comment/CommentBoxEditor';
export default withFeatureBranch({
    editor_comment: CommentBoxEditorV2
})(CommentBoxEditor);

//# sourceMappingURL=index.js.map